import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
	return (
		<div className="not-found">
			<p>죄송합니다. 페이지를 찾을 수 없습니다.</p>
			<Link className="btn btn-outline-primary submit-btn" to="/">
				메인으로
			</Link>
		</div>
	);
}

export default NotFound;
